import React from 'react';

const useScroll = (blocked) => {
  React.useEffect(() => {
    if (blocked) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [blocked]);
};

export default useScroll;
